import { TFunction } from 'react-i18next';
import { PageTabItem } from 'src/shared/components/navigations/pageTabNavigation';
import { RoutesEnum } from 'src/shared/models/enums/routes.enum';

export const helpArticlesPageTabs = (t: TFunction): PageTabItem[] => [
  {
    label: t('helpArticles:tabs.categories'),
    route: RoutesEnum.HelpArticleCategories,
    rawLabel: true,
  },
  {
    label: t('helpArticles:tabs.articles'),
    route: RoutesEnum.HelpArticles,
    rawLabel: true,
  },
];
